import React from "react";
import { Button, Dropdown, Menu, Message } from "@arco-design/web-react";
import { IconBulb, IconLoading } from "@arco-design/web-react/icon";
import { useAuth0 } from "@auth0/auth0-react";
import { PostApi } from "../Api/AuthenticatedApi";

// The AI rewrite styles offered in the dropdown. Keys must match the backend
// allowlist (suggestions.rewriteStyles).
export const REWRITE_STYLES = [
  { key: "shorter", label: "Make it shorter" },
  { key: "friendly", label: "Friendlier" },
  { key: "formal", label: "More formal" },
  { key: "urgent", label: "More urgent" },
  { key: "grammar", label: "Fix grammar" },
];

// A small "Improve" dropdown that rewrites the supplied copy with AI and hands
// the result back via onResult. Reusable next to any subject/body field.
export default function ImproveButton({ text, onResult, disabled, size = "small" }) {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = React.useState(false);

  const run = (style) => {
    if (!text || !text.trim()) {
      Message.warning("Write something first, then I can improve it");
      return;
    }
    setLoading(true);
    PostApi(
      getAccessTokenSilently,
      "/api/rewrite-copy/",
      (data) => {
        setLoading(false);
        if (data && data.response) {
          onResult(data.response);
          Message.success("Updated with AI");
        }
      },
      () => setLoading(false),
      () => {
        setLoading(false);
        Message.error("Couldn't improve that — please try again");
      },
      { style, text },
    );
  };

  const droplist = (
    <Menu onClickMenuItem={(k) => run(k)}>
      {REWRITE_STYLES.map((s) => (
        <Menu.Item key={s.key}>{s.label}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown droplist={droplist} trigger="click" disabled={disabled || loading} position="br">
      <Button size={size} type="text" disabled={disabled} icon={loading ? <IconLoading /> : <IconBulb />}>
        Improve
      </Button>
    </Dropdown>
  );
}
